import React from 'react';
import ChecklistChoice from './ChecklistChoice';

// Maps choice index to Thai alphabet labels (ก, ข, ค, ...)
const THAI_LABELS = ['ก', 'ข', 'ค', 'ง', 'จ', 'ฉ', 'ช'];

/**
 * White card for a single assessment question.
 *
 * @param {number}   questionNumber   - display number (1-based)
 * @param {string}   questionText     - question body text
 * @param {Array}    choices          - question_value array from API: [{ _id, answer, label, score }]
 * @param {string}   selectedChoiceId - _id of the currently selected choice (or null)
 * @param {function} onChoiceSelect   - called with (choice) when a choice is tapped
 */
const ChecklistQuestion = ({
  questionNumber,
  questionText,
  choices = [],
  selectedChoiceId,
  onChoiceSelect,
}) => (
  <div className="checklist-question">
    <div className="checklist-question__text">{questionText}</div>
    <div className="checklist-question__choices">
      {choices.map((choice, index) => (
        <ChecklistChoice
          key={choice._id}
          active={selectedChoiceId === choice._id}
          choiceLabel={THAI_LABELS[index] || String(index + 1)}
          choiceText={choice.answer || choice.label}
          onClick={() => onChoiceSelect(choice)}
        />
      ))}
    </div>
  </div>
);

export default ChecklistQuestion;
